/* @flow */

import { errorColor } from '@e180/ui/lib/token/color';

export default {
  root: {
    backgroundColor: 'transparent',
    border: ({ accentColor }: Object) => `solid 1px ${accentColor}`,
    color: ({ accentColor }: Object) => accentColor,
    fill: ({ accentColor }: Object) => accentColor,
    stroke: ({ accentColor }: Object) => accentColor,

    WebkitFontSmoothing: 'antialiased',

    '&:hover': {
      backgroundColor: ({ r, g, b }: Object) => `rgba(${r},${g},${b},0.05)`,
    },

    '&:active': {
      backgroundColor: 'transparent',
    },
  },
  'root-withError': {
    color: [errorColor, '!important'],
    borderColor: `${errorColor} !important`,
  },
};
